/** @format */

import {Box} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import {TOOLTIP_TEXTS, ATTRIBUTION_OPTIONS} from '../Form/constants';
import FieldLabelWithHelp from '../Form/components/FieldLabelWithHelp';
import SelectField from '../Form/components/SelectField';
import {SelectFieldProps} from '../../types';

interface AttributionModelFieldProps {
  attributionModel: string;
  onAttributionChange: SelectFieldProps['onChange'];
  disabled?: boolean;
}

const AttributionModelField = ({
  attributionModel,
  onAttributionChange,
  disabled = false,
}: AttributionModelFieldProps) => {
  const {t} = useTranslation();

  return (
    <Box>
      <FieldLabelWithHelp tooltipText={TOOLTIP_TEXTS.ATTRIBUTION}>
        <Trans>Модель атрибуции</Trans>
      </FieldLabelWithHelp>
      <SelectField
        value={attributionModel}
        onChange={onAttributionChange}
        options={ATTRIBUTION_OPTIONS}
        placeholder={t('Выбрать')}
        disabled={disabled}
      />
    </Box>
  );
};

export default AttributionModelField;
